import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Tooltip, type TooltipProps } from 'antd';
import type { SpaceSize } from 'antd/es/space';

type PosTooltipProps = TooltipProps & {
  hidden?: boolean;
  spacing?: SpaceSize | number;
  showIcon?: boolean;
  icon?: IconDefinition;
  iconPosition?: 'left' | 'right';
};

export const PosTooltip = ({
  iconPosition = 'right',
  spacing = 'small',
  showIcon = false,
  icon,
  children,
  ...props
}: PosTooltipProps) => {
  if (props.hidden ?? false) {
    return <>{children}</>;
  }

  return (
    <Tooltip {...props}>
      <Flex gap={spacing} wrap align="center">
        {iconPosition === 'right' && children}
        {showIcon && <FontAwesomeIcon icon={icon ?? faQuestionCircle} />}
        {iconPosition === 'left' && children}
      </Flex>
    </Tooltip>
  );
};
